// import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
// import React, { memo, useContext, useEffect, useState } from 'react'
// import { AuthenticationContext } from '../../context/AuthenticationContext'
// import { WmcContext } from '../../context/WmcContext'
// import { WEB_KEY } from '../../api/AxiosApi'
// import Image from 'mui-image'
// import { BaseUrl } from '../../api/AxiosApi'
// import { AppThemeContext } from '../../context/AppThemeContext'
// import { logApi } from '../../api/Api'

// function TopHeader() {
//     const [logData, setLogData] = useState([]);
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const { LoggedInUserInfo } = useContext(AuthenticationContext)
//     const { BrandLogo } = useContext(WmcContext)
//     const { breakpoints, spacing } = useTheme()
//     const LOGIN_ID = sessionStorage.getItem('LoginID')
//     //const LOC_CODE = sessionStorage.getItem('LCODE')
//     const matches = useMediaQuery(breakpoints.down('xl'));
//     // console.log('DATAUSER', LoggedInUserInfo)
//     const LOC_CODE = LoggedInUserInfo?.Loc_Code
//     const PASS_KEY = "xxxxxx"

//     // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"



//     // const ImageUrl = `https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
//     const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`





//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: sessionStorage.getItem("LoginID"),
//         LOC_CODE: sessionStorage.getItem("LCODE"),
//         PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//         WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
//     });


//     // this is fetching for MIDDLE data
//     const fetchLogData = async () => {
//         const res = await logApi(credentials);
//         if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//             setLogData(res.TOT_LIVE_KW_NEW);
//         } else {
//             setLogData([]);
//         }
//     };

//     useEffect(() => {
//         fetchLogData(); // Fetch data initially
//     }, [credentials.LOGIN_ID]); // Dependency ensures it updates when LOGIN_ID changes

//     console.log("logDatatop", logData)

//     return (
//         <Stack rowGap={spacing(1)}  sx={{ bgcolor: 'black' }}>
//             <Card elevation={0} sx={{ bgcolor: 'black' }}>
//                 <CardActions>
//                     <marquee>
//                         {/* <Typography variant='body1' color={'background.default'}>
//                             Industrial Energy Management System Flow Meter & Ground Water Monitoring Smart Metering and DLMS Solution Industrial Energy Management System Flow Meter & Ground Water Monitoring
//                         </Typography> */}
//                         {logData.map((item, index) => (
//                             <Typography variant='body1' color={'white'} key={index}>

//                                 {item?.INV_NO > 0 && (
//                                     <span>
//                                         Total Inverter/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.INV_NO}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;


//                                 {item?.SOLAR_MTR_NO > 0 && (
//                                     <span>
//                                         Total Solar Meter/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.SOLAR_MTR_NO}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;

//                                 {item?.LT_MAINS_NO > 0 && (
//                                     <span>
//                                         Total LT MAINS/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.LT_MAINS_NO}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;

//                                 {item?.DG_NO > 0 && (
//                                     <span>
//                                         Total DG/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.DG_NO}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;

//                                 {item?.NET_METER_NO > 0 && (
//                                     <span>
//                                         Total Net Meter/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.NET_METER_NO}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;

//                                 {item?.CHECK_METER > 0 && (
//                                     <span>
//                                         Total Check Meter/s&nbsp;
//                                         <span style={{  fontSize: "14px", fontWeight: "bold",color:"red" }}>{item.CHECK_METER}</span>
//                                     </span>
//                                 )}&nbsp;&nbsp;&nbsp;&nbsp;

//                                 {/* <span>
//                                 Industrial Energy Management System Flow Meter & Ground Water Monitoring Smart Metering and DLMS Solution Industrial Energy Management System Flow Meter & Ground Water Monitoring
//                                 </span> */}
//                             </Typography>
//                         ))}



//                     </marquee>
//                 </CardActions>
//             </Card>
//             <Grid container spacing={spacing(1)} sx={{ bgcolor: 'black',color:"white" }}>
//                 <Grid item xs={12} sm={12} md={4} >
//                     <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
//                         <Stack>
//                             <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfo?.username}&nbsp; &nbsp;<span>(User_Id:{LOGIN_ID})</span></Typography>
//                             <Typography textAlign={'start'} variant='body1'>Plant Capacity : {LoggedInUserInfo?.PLANT_CAPACITY}</Typography>
//                             <Typography textAlign={'start'} variant='body1'> {LoggedInUserInfo?.Address} &nbsp;, &nbsp;<span>({LoggedInUserInfo?.city})</span></Typography>
//                         </Stack>
//                     </Card>
//                 </Grid>
//                 <Grid item xs={12} sm={12} md={4}>
//                     <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
//                         <Stack>
//                             <Typography variant='body1'>{LoggedInUserInfo?.MSG}</Typography>
//                             <Typography variant='body1' sx={{ color: PrimaryColor }}>Plant Commissioned Date:{LoggedInUserInfo?.PLANT_COMMISSIONED_DATE}</Typography>
//                             <Typography variant='body1' sx={{ color: PrimaryColor }}>Subscription Expiry Date:{LoggedInUserInfo?.subscription_expiry_date}</Typography>
//                         </Stack>
//                     </Card>
//                 </Grid>
//                 <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
//                     <Image fit='fill'
//                         wrapperStyle={{
//                             height: matches ? 50 : 70, borderRadius: "11px",
//                             overflow: "hidden"
//                         }}
//                         src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
//                     />
//                 </Grid>
//             </Grid>
//         </Stack >
//     )
// }

// export default memo(TopHeader)


import { Box, Card, CardActions, CardContent, CardMedia, Grid, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useContext, useEffect, useState } from 'react'
import { AuthenticationContext } from '../../context/AuthenticationContext'
import { WmcContext } from '../../context/WmcContext'
import { WEB_KEY } from '../../api/AxiosApi'
import Image from 'mui-image'
import { BaseUrl } from '../../api/AxiosApi'
import { AppThemeContext } from '../../context/AppThemeContext'
import { logApi, MainSumApi } from '../../api/Api'
import { getDateTimeForDashboardTab1 } from '../../utils'
import { GiFruitTree } from "react-icons/gi";
import { MdCo2 } from "react-icons/md";
import { MdOutlineCo2 } from "react-icons/md";

import { GiReceiveMoney } from "react-icons/gi";

function TopHeader() {
    const [logData, setLogData] = useState([]);
    const { PrimaryColor } = useContext(AppThemeContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const { BrandLogo } = useContext(WmcContext)
    const { breakpoints, spacing } = useTheme()
    const LOGIN_ID = sessionStorage.getItem('LoginID')
    //const LOC_CODE = sessionStorage.getItem('LCODE')
    const matches = useMediaQuery(breakpoints.down('xl'));
    // console.log('DATAUSER', LoggedInUserInfo)
    const LOC_CODE = LoggedInUserInfo?.Loc_Code
    const PASS_KEY = "xxxxxx"

    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)


    // const ImageUrl = "https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=2402104&LOC_CODE=200ET&PASS_KEY=xxxxxx&WEB_KEY=WEBXYZ321"



    // const ImageUrl = `https://log.solaramr.com/api/CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`
    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${LOGIN_ID}&LOC_CODE=${LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`





    const [credentials, setCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID"),
        LOC_CODE: sessionStorage.getItem("LCODE"),
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
        WEB_KEY: sessionStorage.getItem("WEB_KEY") || "WEBXYZ321",
    });


    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    useEffect(() => {
        fetchLogData(); // Fetch data initially
    }, [credentials.LOGIN_ID]); // Dependency ensures it updates when LOGIN_ID changes

    // This fetching for total inverters


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });

    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };


    useEffect(() => {
        fetchData();
    }, [sumCredentials]);


    return (
        <Stack rowGap={spacing(1)}>
            <Card elevation={0} sx={{ bgcolor: 'lightgray' }} >
                <CardActions >
                    <Typography sx={{ marginLeft: "6rem" }}>
                        <Typography>
                            {mainData.map((item, index) => (
                                <span
                                    key={index}
                                    direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation"
                                >
                                    <Typography variant="p"><span style={{ fontSize: "1.3rem", color: "#2E6F40" }}><GiReceiveMoney /></span> Revenue Gains({LoggedInUserInfo?.CURRENCY}) &nbsp;<span style={{ color: "#2E6F40", fontSize: "14px", fontWeight: "bold" }}>{item.TOT_Rev !== undefined ? item.TOT_Rev : "N/A"}</span></Typography> &nbsp;&nbsp;&nbsp;
                                    <Typography variant="p"><span style={{ fontSize: "1.4rem", color: "#2E6F40" }}><MdOutlineCo2 style={{ width: "30px", height: "30px" }} /></span> Reduction &nbsp;<span style={{ color: "#2E6F40", fontSize: "14px", fontWeight: "bold" }}>{item.co2_ton !== undefined ? item.co2_ton : "N/A"}</span></Typography>&nbsp;&nbsp;&nbsp;
                                    {/* <Typography variant="p"><span style={{fontSize:"1.4rem",color:PrimaryColor}}><img style={{ color:PrimaryColor}} src={Load} alt="load" className="dashboard-icon" /></span> Reduction &nbsp;<span style={{color:PrimaryColor}}>{item.co2_ton !== undefined ? item.co2_ton : "N/A"}</span></Typography>&nbsp;&nbsp;&nbsp; */}
                                    <Typography variant="p"><span style={{ fontSize: "1.3rem", color: "#2E6F40" }}><GiFruitTree /></span>Tree Saved &nbsp;<span style={{ color: "#2E6F40", fontSize: "14px", fontWeight: "bold" }}>{item.TOT_tree !== undefined ? item.TOT_tree : "N/A"}</span></Typography>

                                </span>
                            ))}

                            &nbsp;&nbsp;&nbsp;&nbsp;

                            {logData.map((item, index) => (
                                <span variant='body1' color={'black'} key={index}>

                                    {item?.INV_NO > 0 && (
                                        <span>
                                            Total Inverter/s&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.INV_NO}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;


                                    {item?.SOLAR_MTR_NO > 0 && (
                                        <span>
                                            Total Solar Meter/s&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.SOLAR_MTR_NO}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;

                                    {item?.LT_MAINS_NO > 0 && (
                                        <span>
                                            Total LT MAINS&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.LT_MAINS_NO}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;

                                    {item?.DG_NO > 0 && (
                                        <span>
                                            Total DG/s&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.DG_NO}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;

                                    {item?.NET_METER_NO > 0 && (
                                        <span>
                                            Main ABT Meter&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.NET_METER_NO}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;

                                    {item?.CHECK_METER > 0 && (
                                        <span>
                                            Total Check Meter/s&nbsp;
                                            <span style={{ fontSize: "14px", fontWeight: "bold", color: "#2E6F40" }}>{item.CHECK_METER}</span>
                                        </span>
                                    )}&nbsp;&nbsp;&nbsp;&nbsp;

                                    {/* <span>
                                Industrial Energy Management System Flow Meter & Ground Water Monitoring Smart Metering and DLMS Solution Industrial Energy Management System Flow Meter & Ground Water Monitoring
                                </span> */}
                                </span>
                            ))}

                        </Typography>

                    </Typography>
                </CardActions>
            </Card>
            <Grid container spacing={spacing(1)}>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography textAlign={'start'} variant='body1'>{LoggedInUserInfo?.username}&nbsp; &nbsp;<span>(User_Id:{LOGIN_ID})</span></Typography>
                            {/* <Typography textAlign={'start'} variant='body1'>Plant Capacity : {LoggedInUserInfo?.PLANT_CAPACITY}   </Typography> */}
                             <Typography textAlign={'start'} variant='body1'>Plant AC Capacity : {LoggedInUserInfo?.PLANT_CAPACITY} {LoggedInUserInfo?.AC_Unit} &nbsp; &nbsp; Plant DC Capacity : {LoggedInUserInfo?.DC_CAPACITY} {LoggedInUserInfo?.DC_Unit}</Typography> 
                            <Typography textAlign={'start'} variant='body1'> {LoggedInUserInfo?.Address} &nbsp;, &nbsp;<span>({LoggedInUserInfo?.city})</span></Typography>
                        </Stack>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Card sx={{ height: matches ? 50 : 70, p: spacing(1), display: 'flex', alignItems: "center" }}>
                        <Stack>
                            <Typography variant='body1'>{LoggedInUserInfo?.MSG}</Typography>
                            <Typography variant='body1' sx={{ color: PrimaryColor }}>Plant Commissioned Date:{LoggedInUserInfo?.PLANT_COMMISSIONED_DATE}</Typography>
                            <Typography variant='body1' sx={{ color: PrimaryColor }}>Subscription Expiry Date:{LoggedInUserInfo?.subscription_expiry_date}</Typography>
                        </Stack>
                    </Card>
                </Grid>

                {/* <Grid item xs={12} sm={12} md={4} display={'flex'} justifyContent={'center'}>
                    <Image fit='fill'
                        wrapperStyle={{
                            height: matches ? 50 : 70, borderRadius: "11px",
                            overflow: "hidden"
                        }}
                        src={ImageUrl ? ImageUrl : require('../../assets/img/basic/battery.png')}
                    />
                </Grid> */}

                <Grid item xs={12} sm={12} md={4} display="flex" justifyContent="center">

                    <Card
                        sx={{
                            width: "100%",
                            height: matches ? 50 : 70,
                            p: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            borderRadius: "5px"
                        }}
                    >
                        <img
                            src={require("../../assets/img/logos/LTNewLogo.png")}
                            alt="logo"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"   // 👉 cover भी कर सकते हो
                            }}
                        />
                    </Card>

                </Grid>
                
            </Grid>
        </Stack >
    )
}

export default memo(TopHeader)
